<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Finish Good Quality Inspection">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Finish Good Quality Inspection" class="mb-3">
            <b-row>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" :isEditable="false" :isUpdatable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" />
					<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="model.qtyBefore" :isEditable="false" />
					<app-input-textbox id="fieldset-qty-pending" label-cols-lg="12"  label="Qty Pending" label-for="input-qty-pending" size="sm" :model.sync="model.qtyPending" :isEditable="isAllowUpdate" @change="updateData" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-radio :options="metodeQcs" text-field="name" value-field="id" label-cols-lg="12" label="Metode Qc" id="fieldset-metode-qc" size="sm" :model.sync="model.metodeQcId" :isEditable="false" />
					<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="model.qtyAfter" :isEditable="isAllowUpdate" @change="updateData" />
					<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12"  label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="totalNg" :isEditable="false" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-custom title="Finish Good Quality Inspection Ng" :bordered="true"
			:items="finishGoodQualityInspectionNgs" :fields="fieldsFinishGoodQualityInspectionNg"
			:busy="isDataLoading" :sort-by.sync="sortByFinishGoodQualityInspectionNg"
			:sort-desc.sync="sortDescFinishGoodQualityInspectionNg" small responsive
			@editButtonMethod="editRowDataFinishGoodQualityInspectionNg"
			@deleteButtonMethod="deleteRowDataFinishGoodQualityInspectionNg"
			@showPopupAddMethod="addDataFinishGoodQualityInspectionNg()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQualityInspectionNg()"
			@downloadMethod="downloadFinishGoodQualityInspectionNg()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQualityInspectionNg()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQualityInspectionNg()"
			:showActionButton="isAllowUpdate" :showDeleteButton="isAllowUpdate" :showAddButton="isAllowUpdate"
			:showAddFromClipboardButton="false" :showReplaceFromClipboardButton="false" :showUploadButton="false"
			:showDownloadButton="false" :isDownloadBusy="isDownloadFinishGoodQualityInspectionNg">

			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowFinishGoodQualityInspectionNgFilter = !isShowFinishGoodQualityInspectionNgFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>  -->

			<template #top-row v-if="isShowFinishGoodQualityInspectionNgFilter">
				<b-th></b-th>
				<b-th stacked-heading="Problem Category">
					<v-select id="input-finish-good-quality-inspection-ng-problem-category-table" append-to-body
						label="code" :options="problemCategorys"
						:value="filterFinishGoodQualityInspectionNg.problemCategoryId" :reduce="item => item.id"
						v-model="filterFinishGoodQualityInspectionNg.problemCategoryId"
						@search="getProblemCategorys" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Ng">
					<b-form-input id="input-finish-good-quality-inspection-ng-qty-ng-table"
						v-model="filterFinishGoodQualityInspectionNg.qtyNg" size="sm" :type="number"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>

			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + (finishGoodQualityInspectionNgPageSize *
	(currentFinishGoodQualityInspectionNgPage - 1))) }}
			</template>

			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>

			<template v-slot:cell(problemCategory)="row">
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="name" optionsKey="id"
					:id="'input-finish-good-quality-inspection-ng-problem-category-' + row.index" label-cols-lg="12"
					label="Problem Category" size="sm" :model.sync="row.item.problemCategoryId"
					:state="validateState('problemCategoryId')"
					:errorMessage="getErrorMessage(errorMessage.problemCategoryId, 'problemCategoryId')"
					@change="saveInputFinishGoodQualityInspectionNg(row.item)"
					:selected="row.item.problemCategory != null ? row.item.problemCategory.name : ''"
					@input="getProblemCategorys" :loading="isProblemCategoryComboLoading" :reloadData="true"
					:nolabel="true" :isEditable="isAllowUpdate" />
			</template>
			<template v-slot:cell(qtyNg)="row">
				<app-input-textbox :id="'input-finish-good-quality-inspection-ng-qty-ng-' + row.index"
					label-cols-lg="12" label="Qty Ng" size="sm" :model.sync="row.item.qtyNg" :isEditable="isAllowUpdate"
					@change="saveInputFinishGoodQualityInspectionNg(row.item)" :nolabel="true" type="number" />
			</template>

			<template v-slot:cell(evidence)="row">
				<div v-if="modalSource == 'revise'">
					<app-input-fileupload :id="'input-evidence-attachment-file-pendukung-' + row.index" label-cols-lg="12" label="File Pendukung" size="sm" :model.sync="filePendukungs[row.item.id]" :currentModel="row.item.evidence" @change="saveInputEvidenceAttachment(row.item)" :isEditable="true"  :nolabel="true" accept="image/*" />
				</div>				
				<div v-else>
					<b-button v-if="row.item.evidenceId" :id="'input-finish-good-quality-inspection-ng-' + row.index" @click="showImage(row.item)" size="sm" variant="primary">Show Evidence</b-button>
				</div>
			</template>


			<template v-slot:form-add-detail>
				<FinishGoodQualityInspectionNgInput :model="modelFinishGoodQualityInspectionNg"
					:openPopup="isShowPopupFinishGoodQualityInspectionNg" @resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQualityInspectionNg" />
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQualityInspectionNgUpload :openPopup="isShowPopupUploadFinishGoodQualityInspectionNg"
					@resetMethod="resetModal" @uploadButtonMethod="uploadDataFinishGoodQualityInspectionNg"
					:parentId="modelId" />
			</template>
			</app-table-input-custom>
		<!-- <app-table-input-popup title="Finish Good Quality Inspection Ng" :bordered="true" :items="finishGoodQualityInspectionNgs" :fields="fieldsFinishGoodQualityInspectionNg" :busy="isDataLoading" :sort-by.sync="sortByFinishGoodQualityInspectionNg" :sort-desc.sync="sortDescFinishGoodQualityInspectionNg" small responsive
			@editButtonMethod="editRowDataFinishGoodQualityInspectionNg"
			@deleteButtonMethod="deleteRowDataFinishGoodQualityInspectionNg"
			@showPopupAddMethod="resetDataFinishGoodQualityInspectionNg()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQualityInspectionNg()"
			@downloadMethod="downloadFinishGoodQualityInspectionNg()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQualityInspectionNg()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQualityInspectionNg()"
			:showActionButton="isAllowUpdate"
			:showEditButton="isAllowUpdate"
			:showDeleteButton="isAllowUpdate"
			:showAddButton="isAllowUpdate"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadFinishGoodQualityInspectionNg"
			>
			<template #top-row v-if="isShowFinishGoodQualityInspectionNgFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Problem Category">
					<v-select append-to-body label="code" :options="problemCategorys"  :value="filterFinishGoodQualityInspectionNg.problemCategoryId" :reduce="item => item.id" v-model="filterFinishGoodQualityInspectionNg.problemCategoryId" @search="getProblemCategorys" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Ng">
					<b-form-input id="input-qty-ng-table" v-model="filterFinishGoodQualityInspectionNg.qtyNg" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( finishGoodQualityInspectionNgPageSize * (currentFinishGoodQualityInspectionNgPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(problemCategory)="row">
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="code" optionsKey="id" :id="'input-finish-good-quality-inspection-ng-problem-category-' + row.index" label-cols-lg="12" label="Problem Category" size="sm" :model.sync="row.item.problemCategoryId" :state="validateState('problemCategoryId')" :errorMessage="getErrorMessage(errorMessage.problemCategoryId, 'problemCategoryId')"  @change="saveInputFinishGoodQualityInspectionNg(row.item)" :selected="row.item.problemCategory != null ? row.item.problemCategory.code : ''"  @input="getProblemCategorys" :loading="isProblemCategoryComboLoading"   :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyNg)="row">
				<app-input-textbox :id="'input-finish-good-quality-inspection-ng-qty-ng-' + row.index" label-cols-lg="12" label="Qty Ng" size="sm" :model.sync="row.item.qtyNg"   @change="saveInputFinishGoodQualityInspectionNg(row.item)"  :isEditable="false"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<FinishGoodQualityInspectionNgInput 
					:openPopup="isShowPopupFinishGoodQualityInspectionNg"
					:modelId="finishGoodQualityInspectionNgId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQualityInspectionNg"/>
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQualityInspectionNgUpload
					:openPopup="isShowPopupUploadFinishGoodQualityInspectionNg"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataFinishGoodQualityInspectionNg"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-textbox :id="'input-finish-good-quality-inspection-ng-qty-ng-' + row.index" label-cols-lg="12" label="Qty Ng" size="sm" :model.sync="row.item.qtyNg"   @change="saveInputFinishGoodQualityInspectionNg(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup> -->
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-left-button>
			<b-button size="sm" class="float-right btn-outline-success mr-1" @click="printCard" v-if="model.qtyPending > 0">Print Card</b-button>
		</template>

		<PopupPDF :openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label="Image Evidence" />
    </b-modal>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';
import FinishGoodQualityInspectionList from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionList';
import FinishGoodQualityInspectionFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputRadio from '@/components/AppInputRadio';
import MetodeQc from '@/models/MetodeQc/MetodeQc';
import MetodeQcFilter from '@/filters/MetodeQc/MetodeQcFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import FinishGoodQualityInspectionNg from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionNg';
import FinishGoodQualityInspectionNgFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionNgFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import AppTableInputCustom from '@/components/AppTableInputCustom';
import FinishGoodQualityInspectionNgInput from '@/views/FinishGoodQualityInspection/FinishGoodQualityInspectionNgInput';
import FinishGoodQualityInspectionNgUpload from '@/views/FinishGoodQualityInspection/FinishGoodQualityInspectionNgUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';
import AppInputFileupload from '@/components/AppInputFileupload';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputRadio,
		FinishGoodQualityInspectionNgInput,FinishGoodQualityInspectionNgUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		AppTableInputCustom,
		PopupPDF,
		AppInputFileupload,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod', 'modalSource'],
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsFinishGoodQualityInspectionNg: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"problemCategory": { "class" : "th-problem-category first-child", "label" : "Problem Category", key: 'problemCategory', sortable: false}}, 
				{"qtyNg": { "class" : "th-qty-ng", "label" : "Qty Ng", key: 'qtyNg', sortable: false}}, 
				{"evidence": { "class" : "th-evidence", "label" : "Evidence", key: 'evidence', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			model: {},
			modelFinishGoodQualityInspectionNg : {},
			isShowPopupFinishGoodQualityInspectionNg : false,
			isShowPopupUploadFinishGoodQualityInspectionNg : false,
			filterFinishGoodQualityInspection : null,
			currentFinishGoodQualityInspectionPage : 1,
			finishGoodQualityInspectionPageSize: 10,
			sortByFinishGoodQualityInspection: '',
			sortDescFinishGoodQualityInspection: '',
			filterFinishGoodQualityInspectionNg : null,
			currentFinishGoodQualityInspectionNgPage : 1,
			finishGoodQualityInspectionNgPageSize: 10,
			sortByFinishGoodQualityInspectionNg: '',
			sortDescFinishGoodQualityInspectionNg: '',
			sortingByFinishGoodQualityInspectionNg: [],
			finishGoodQualityInspectionNgs : [],
			finishGoodQualityInspectionNgId : '',
			totalFinishGoodQualityInspectionNgRow : 0,
			isShowFinishGoodQualityInspectionNgFilter: false,
			isDownloadFinishGoodQualityInspectionNg: false,
			problemCategorys: [],
			controlCards: [],
			isControlCardComboLoading: false,
			metodeQcs: [],
			isMetodeQcComboLoading: false,
			parts: [],
			isPartComboLoading: false,
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isFinishGoodQualityInspectionComboLoading: false,
			isProblemCategoryComboLoading: false,
			pdfUrl: '',
			isShowPopupPDF: false,
			filePendukungs: [],
		}
	},
	methods : {
		saveInputEvidenceAttachment(item) {
			this.isDataLoading = true;

			let id = item.id;
			let promises = Array();
			if (this.filePendukungs[id] != null) {
				this.isInputBusy = true;
				let data = new FormData();
				data.append('file', this.filePendukungs[id]);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								item.evidenceId = response.data.id;
								item.evidence = response.data;
								//_this.filePendukungs[id] = null;
							}
						}

						_this.isInputBusy = false;
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isInputBusy = false;
						throw error;
					}));
			}
			else {
				item.evidence = null;
				item.evidenceId = null;
				this.filePendukungs[id] = null;
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectionNg.updateData(this, item, item.id);
				}

				this.isDataLoading = false;
			});
			this.isDataLoading = false;
		},
		async showImage(item) {
			this.isBusy = true;
			
			const  result = await FinishGoodQualityInspectionNg.showImageEvidence(this, item.id);
			if (result == null) {
				this.toast({message: 'Quality Control Detail Reference tidak ditemukan.', title: 'Message', variant: 'warning'});
				this.isBusy = false;
			}
			this.isBusy = false;
			this.pdfUrl = result.download;
			this.isShowPopupPDF = true;
		},
		async addButtonAction(modalEvent) {
			modalEvent.preventDefault();
			let _this = this;
			let isChanged = false;
			
			this.model.qtyNg = this.totalNg

			if(this.isAllowUpdate) {
				//await FinishGoodQualityInspection.updatDataDetail(this, this.model, this.model.id)
				await this.$http.put(`FinishGoodQualityInspection/commit/${this.model.id}`)
					.then(() => {
						_this.$emit("addButtonMethod", modalEvent, _this.model);
						this.$nextTick(() => { this.$v.$reset(); });
					})
					.catch((error) => {
						//this.getFinishGoodQualityInspection(this.model.id);
						this.$store.dispatch('addErrorMessageGlobal', error); // Handle the error
						return;
					});
			} else {
				_this.$emit("addButtonMethod", modalEvent, _this.model);
				this.$nextTick(() => { this.$v.$reset(); });
			}
				
			

		},
		async printCard(){
			this.isBusy = true;
			let controlCardId = this.model != null ? this.model.controlCardId : 0;
			// console.log('controlCardId',controlCardId)
			try {
				let ids = [];
				ids.push(controlCardId);
				let result = await ControlCard.printControlCard(this_, ids);
				this.toast({message: "Print Card berhasil", variant:"success", title: "Success" })
				this.isBusy = false;
			} catch {
				this.isBusy = false;
			}
		},
		getFinishGoodQualityInspection : async function(id) {
			this.isBusy = true;
			FinishGoodQualityInspection.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadFinishGoodQualityInspection = true;
			this.filterFinishGoodQualityInspection.id = this.modelId;
			FinishGoodQualityInspection.downloadDataDetail(this, this.filterFinishGoodQualityInspection).then(result => {
				this.isDownloadFinishGoodQualityInspection = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspection = false; })
		},
		getFinishGoodQualityInspectionNgs : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterFinishGoodQualityInspectionNg);
			if (this.modelId == null) return;
			filter.finishGoodQualityInspectionId = this.modelId;
			//filter.draftMode = "0,1";
			if (this.sortByFinishGoodQualityInspectionNg != null) {
				this.sortingByFinishGoodQualityInspectionNg[this.sortByFinishGoodQualityInspectionNg] = this.sortDescFinishGoodQualityInspectionNg;
			}
			let currentPage = (this.currentFinishGoodQualityInspectionNgPage - 1);
			if (isAddRow) {
				let totalData = this.totalFinishGoodQualityInspectionNgRow + 1;
				let page = Math.ceil(totalData/this.finishGoodQualityInspectionNgPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.finishGoodQualityInspectionNgPageSize = 0;
			// disable paging end
			FinishGoodQualityInspectionNg.getList(this, filter, this.sortingByFinishGoodQualityInspectionNg, currentPage , this.finishGoodQualityInspectionNgPageSize).then(result => {
				this.currentFinishGoodQualityInspectionNgPage = currentPage + 1;
				this.finishGoodQualityInspectionNgs = result.data;
				this.totalFinishGoodQualityInspectionNgRow = result.dataCount;
			}).catch(error => {});
		},
		getFinishGoodQualityInspections : async function(input) {
			let filter = new FinishGoodQualityInspectionFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isFinishGoodQualityInspectionComboLoading = true;
			FinishGoodQualityInspection.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspections = result.data
				}
				this.isFinishGoodQualityInspectionComboLoading = false;
			})
			.catch(error => {});
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isProblemCategoryComboLoading = true;
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
				this.isProblemCategoryComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getMetodeQcs : async function(input) {
			let filter = new MetodeQcFilter();
			if (input != undefined) {
				filter.name = input;
			}
			MetodeQc.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.metodeQcs = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedMetodeQc(item) {
			if(item == undefined || item == null) {
				this.model.metodeQcId = null;
				this.model.metodeQc = null;
			} else {
				this.model.metodeQcId = item.id;
				this.model.metodeQc = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.finishGoodQualityInspectionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspection.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqualityinspectionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					FinishGoodQualityInspection.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqualityinspectionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		async updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspection.updateData(this, model, id)
					.catch((error) => {
						this.getFinishGoodQualityInspection(id);
						throw error;
					});
				}
			});
		},
		onHidden() {
			this.getFinishGoodQualityInspections();
		},
		addRowDataFinishGoodQualityInspectionNg(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.finishGoodQualityInspectionId =  this.modelId;
					FinishGoodQualityInspectionNg.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getFinishGoodQualityInspectionNgs(true);
						this.isShowPopupFinishGoodQualityInspectionNg = false;
					})
				} else {
					model.finishGoodQualityInspectionId =  this.modelId;
					FinishGoodQualityInspectionNg.createDataDetail(this, model)
					.then(result => {
						this.getFinishGoodQualityInspectionNgs(true);
						this.isShowPopupFinishGoodQualityInspectionNg = false;
					})
				}
			}
		},
		async editRowDataFinishGoodQualityInspectionNg(id) {
			this.finishGoodQualityInspectionNgId = id;
			this.isShowPopupFinishGoodQualityInspectionNg = true; 
		},
		async deleteRowDataFinishGoodQualityInspectionNg(id) {
			FinishGoodQualityInspectionNg.deleteData(this, id).then(result => { this.getFinishGoodQualityInspectionNgs(); });
		},
		async resetDataFinishGoodQualityInspectionNg() {
			this.finishGoodQualityInspectionNgId = "";
			this.isShowPopupFinishGoodQualityInspectionNg = true;
		},
		async addDataFinishGoodQualityInspectionNg() {
			FinishGoodQualityInspectionNg.createData(this, { finishGoodQualityInspectionId: this.model.id })
			.then(result => {
				this.getFinishGoodQualityInspectionNgs(true);
			})
		},
		async addFromClipboardFinishGoodQualityInspectionNg() {
			let problemCategorys = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					problemCategorys.push({ problemCategory: item, finishGoodQualityInspectionId: this.modelId });
				});
				FinishGoodQualityInspectionNg.addFromClipboard(this, problemCategorys).then(result => { this.getFinishGoodQualityInspectionNgs() });
			});
		},
		async replaceFromClipboardFinishGoodQualityInspectionNg() {
			let problemCategorys = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					problemCategorys.push({ problemCategory: item, finishGoodQualityInspectionId: this.modelId });
				});
				FinishGoodQualityInspectionNg.replaceFromClipboard(this, problemCategorys).then(result => { this.getFinishGoodQualityInspectionNgs() });
			});   
		},
		showPopupUploadFinishGoodQualityInspectionNg() {
			if(this.finishGoodQualityInspectionNgs != null && this.finishGoodQualityInspectionNgs.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap FinishGoodQualityInspectionNg akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadFinishGoodQualityInspectionNg = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadFinishGoodQualityInspectionNg = true;
			}
		},
		uploadDataFinishGoodQualityInspectionNg(modalEvent, newDatas) {
			this.isShowPopupUploadFinishGoodQualityInspectionNg = false; 
		},
		downloadFinishGoodQualityInspectionNg(modalEvent) {
			this.isDownloadFinishGoodQualityInspectionNg = true;
			this.filterFinishGoodQualityInspectionNg.finishGoodQualityInspectionId = this.modelId;
			FinishGoodQualityInspectionNg.downloadDataDetail(this, this.filterFinishGoodQualityInspectionNg).then(result => {
				this.isDownloadFinishGoodQualityInspectionNg = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspectionNg = false; })
		},
		saveInputFinishGoodQualityInspectionNg(item) {
			if (this.finishGoodQualityInspections != null && this.finishGoodQualityInspections != undefined  && this.finishGoodQualityInspections.length > 0) {
				item.finishGoodQualityInspection = this.finishGoodQualityInspections.find(q => q.id == item.finishGoodQualityInspectionId);
			}
			if (this.problemCategorys != null && this.problemCategorys != undefined  && this.problemCategorys.length > 0) {
				item.problemCategory = this.problemCategorys.find(q => q.id == item.problemCategoryId);
			}

			let id = item.id;
			let promises = Array();

			if(item.qtyNg == null || item.qtyNg == undefined) return;

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectionNg.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadFinishGoodQualityInspectionNg = false; 
			this.isShowPopupFinishGoodQualityInspectionNg = false; 
			this.isShowPopupPDF = false;
			if (modalType == 'FinishGoodQualityInspectionNg') {
				this.getFinishGoodQualityInspectionNgs();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;

			this.$emit("addButtonMethod", this.model);
			this.$nextTick(() => { this.$v.$reset(); });
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowFinishGoodQualityInspectionNgFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterFinishGoodQualityInspection = new FinishGoodQualityInspectionFilter();
		this.filterFinishGoodQualityInspectionNg = new FinishGoodQualityInspectionNgFilter();
		//this.getFinishGoodQualityInspections();
		//this.getProblemCategorys();
		//this.getControlCards();
		this.getMetodeQcs();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getFinishGoodQualityInspection(id);
				this.getFinishGoodQualityInspectionNgs();
			} else {
				//this.modelId = id;
				this.getFinishGoodQualityInspection(id);
				this.getFinishGoodQualityInspectionNgs();
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		totalNg() {
			if(this.finishGoodQualityInspectionNgs.length <= 0) return 0;

			let ngQty = 0;
			this.finishGoodQualityInspectionNgs.forEach(item => {
				ngQty += parseFloat(item.qtyNg);
			});

			return ngQty;
		},
		isAllowUpdate() {
			if(this.modalSource == 'revise') return true;
			return false;
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByFinishGoodQualityInspectionNg : {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		sortDescFinishGoodQualityInspectionNg: {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		currentFinishGoodQualityInspectionNgPage: {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		finishGoodQualityInspectionNgPageSize : {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		filterFinishGoodQualityInspectionNg: {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			},
			deep: true,
		},
		modelId(newValue) {
			this.getFinishGoodQualityInspectionNgs();
			this.getFinishGoodQualityInspection(newValue);
		},
		openPopup(newValue) {
			if (newValue) {
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getFinishGoodQualityInspection(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
}
</script>
